/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Url_Numbers_Not_ValidInputs */

const en_common_url_numbers_not_valid = /** @type {(inputs: Common_Url_Numbers_Not_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Numbers alone are not a valid website URL. Try adding a domain like .com`)
};

const es_common_url_numbers_not_valid = /** @type {(inputs: Common_Url_Numbers_Not_ValidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo números no es una URL válida. Prueba agregando un dominio como .com`)
};

/**
* | output |
* | --- |
* | "Numbers alone are not a valid website URL. Try adding a domain like .com" |
*
* @param {Common_Url_Numbers_Not_ValidInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_url_numbers_not_valid = /** @type {((inputs?: Common_Url_Numbers_Not_ValidInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Url_Numbers_Not_ValidInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_url_numbers_not_valid(inputs)
	return en_common_url_numbers_not_valid(inputs)
});